class HeaderDropdown extends HTMLElement {
  constructor() {
    super();
    this.dropdownNode = this.querySelector('.header__dropdown__wrapper');
  }


  connectedCallback() {
    if (this.dropdownNode) {
      const navlinksNodeHeight = this.handleDropdownItemsHeights(this.dropdownNode);
      this.handleDropdownItemsHeightsWider(this.dropdownNode, navlinksNodeHeight);
      const resizeObserver = new ResizeObserver(() => {
        const menuBlockNodes = this.dropdownNode.querySelectorAll('.menu__block');
    
        let maxHeight = 0;
      
        // Find the tallest item
        menuBlockNodes.forEach(menuBlockNode => {
          const imageWrapperNode = menuBlockNode.querySelector('.image-wrapper');
          if (imageWrapperNode) {
            maxHeight = Math.max(maxHeight, imageWrapperNode.offsetHeight);
          }
    
          menuBlockNodes.forEach(menuBlockNode => {
            const imageWrapperNode = menuBlockNode.querySelector('.image-wrapper');
            if (imageWrapperNode) {
              imageWrapperNode.style.height = `${maxHeight}px`;
            }
          });
        });
      });
      resizeObserver.observe(this.dropdownNode);
    }
  }


  handleDropdownItemsHeights(dropdownNode) {
    /*
      This function adjusts the height of image wrapper elements inside 
      a dropdown menu to match the height of the .dropdown__family navigation 
      links container.
    */
    const navLinksNode = dropdownNode.querySelector('.dropdown__family');
    if (!navLinksNode) return;
    
    // Get height without padding and margin
    const computedStyle = window.getComputedStyle(navLinksNode);
    const paddingTop = parseFloat(computedStyle.paddingTop);
    const paddingBottom = parseFloat(computedStyle.paddingBottom);
    let navlinksNodeHeight = navLinksNode.offsetHeight;
    navlinksNodeHeight = navlinksNodeHeight - paddingTop - paddingBottom;
    const menuBlockNodes = dropdownNode.querySelectorAll('.menu__block');
    if (!menuBlockNodes) return;

    menuBlockNodes.forEach((menuBlockNode) => {
      const imageWrapperNode = menuBlockNode.querySelector('.image-wrapper');
      if (imageWrapperNode) {
        if (imageWrapperNode.offsetHeight < navlinksNodeHeight) {
          imageWrapperNode.style.height = navlinksNodeHeight + 'px';
        }
      }
    });
    return navlinksNodeHeight;
  }


  handleDropdownItemsHeightsWider(dropdownNode, navlinksNodeHeight) {
    /*
      This function ensures that all .image-wrapper elements inside .menu__block elements 
      have the same height as the widest navigation image (.menu__block--wide), 
      but only if it is taller than the height of the navlinks height.
    */
    const menuBlockNodes = dropdownNode.querySelectorAll('.menu__block');
    if (!menuBlockNodes) return;

    let menuBlockWiderHeight = 0;
    menuBlockNodes.forEach((menuBlockNode) => {
      if (menuBlockNode.classList.contains('menu__block--wide')) menuBlockWiderHeight = menuBlockNode.offsetHeight;
    });

    if (menuBlockWiderHeight > navlinksNodeHeight) {
      menuBlockNodes.forEach((menuBlockNode) => {
        const imageWrapperNode = menuBlockNode.querySelector('.image-wrapper');
        if (imageWrapperNode) {
          imageWrapperNode.style.height = menuBlockWiderHeight + 'px';
        }
      });
    }
  }
}


customElements.define("header-dropdown", HeaderDropdown);
